import React from 'react';
import ContactHistoryTable from 'components/molecules/call-dashboard/forms/history-table';

interface IProps {
  patientGuid: string;
}

const CallDashboardCallHistoryTab: React.FC<IProps> = (props) => {
  const { patientGuid } = props;

  return (
    <div>
      <ContactHistoryTable patientGuid={patientGuid} />
    </div>
  );
};

export default CallDashboardCallHistoryTab;
